
const WpUserRolesOrdered = ["administrator", "editor", "author", "contributor", "subscriber", "none"] as const;
export type WpUserRole = typeof WpUserRolesOrdered[number];

export class WpUser {
    /**
     * 
     * @param role A WordPress user role.
     * @returns True if the user has the role exactly. False otherwise.
     */
    public hasRole(role: WpUserRole): boolean {
        if (role === "none") {
            return true;
        }
        return e5.Plugins.config.userRoles.indexOf(role) !== -1;
    }

    /**
     * @param role A WordPress user role.
     * @returns True if the user has the role or a "higher" role. False otherwise.
     */
    public hasRoleMin(role: WpUserRole): boolean {
        const userIndex = WpUserRolesOrdered.indexOf(this.role);
        const roleIndex = WpUserRolesOrdered.indexOf(role);
        if (roleIndex === -1) {
            console.warn(`Could not check if user is role "${role}". The role "${role}" is unknown.`);
            return false;
        }

        return userIndex <= roleIndex;
    }

    /**
     * @deprecated Use hasRoleMin() instead.
     */
    public hasCap(role: WpUserRole): boolean {
        return this.hasRoleMin(role);
    }    

    public exists(): boolean {
        return e5.Plugins.config.userRoles.length > 0;
    }

    /**
     * @returns The user's role. If the user has multiple roles, the "highest" role is returned.
     */
    public get role(): WpUserRole {
        const userRoles = e5.Plugins.config.userRoles;
        for (const r of WpUserRolesOrdered) {
            if (userRoles.indexOf(r) !== -1) {
                return r;
            }
        }
        return "none";
    }
}